module.exports = __webpack_public_path__ + "static/media/public space development.da61a546.jpg";